module.exports = __webpack_public_path__ + "static/fingerprint-a942b673b82dc55c66b7efebc79c4e3d.svg";